/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: kai.zhou
 * @LastEditTime: 2021-04-25 20:36:52
 */
export default {
  lang: "英语",
  landing: {
    name1: "Open CarlcareApp",
    name2: "Make a reservation",
    name3: "Use CarlcareApp, you can check the ",
    name4: "order information at any time!",
  },
};